<template lang="html">
  <root class="admin-countries">

    <admin-nav></admin-nav>
    <page-header name="Countries" :count="false"></page-header>

    <!-- Data -->
    <div class="container">

      <!-- Add new -->
      <div class="row">
        <div class="col m2 offset-m5">
          <router-link :to="{ name: 'CountryAdd' }" class="waves-effect waves-light btn">Add</router-link>
        </div>
      </div>

      <table class="striped" v-if="countries.length">
        <thead>
          <tr>
            <th>Country (EN)</th>
            <th>Country (AR)</th>
            <th>Country code</th>
            <th>Phone code</th>
            <th>Currency</th>
            <th>Fraction digits</th>
            <th>Hotline</th>
            <th>Flag</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="country in countries">
            <td>{{ country.name.en }}</td>
            <td>{{ country.name.ar }}</td>
            <td>{{ _.toUpper(country.code) }}</td>
            <td>{{ country.phone_code }}</td>
            <td>{{ country.currency }}</td>
            <td>{{ country.currency_fraction_digits }}</td>
            <td>{{ country.hotline }}</td>
            <td>
              <img :src="country.flag" alt="">
            </td>
            <td class="actions">
              <router-link :to="{ name: 'CountryDelete', params: { countryKey: country.code } }">
                <i class="material-icons">delete</i>
              </router-link>
              <router-link :to="{ name: 'CountryEdit', params: { countryKey: country.code } }">
                <i class="material-icons">mode_edit</i>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <preloader :is-active="!countries.length"></preloader>

  </root>
</template>

<script>
import * as firebase from "firebase";
import pageState from "../../plugins/page-state";

export default {
  data() {
    return {
      countries: [],
    };
  },

  methods: {
    // Collect
    collect() {
      firebase
        .database()
        .ref("countries")
        .once("value")
        .then((countriesSnap) => {
          let countriesLoop = countriesSnap.numChildren();

          countriesSnap.forEach((countrySnap) => {
            let country = countrySnap.val();
            country["code"] = countrySnap.key;

            // Flag
            firebase
              .storage()
              .ref("flag/" + country.code + ".png")
              .getDownloadURL()
              .then((flagURL) => {
                country["flag"] = flagURL;
                this.countries.push(country);

                // End loop
                countriesLoop--;
                if (!countriesLoop && this.countries.length) {
                  setTimeout(() => {
                    var table = $("table").DataTable();
                    pageState.filtersBackup(this.$router.currentRoute, table);
                    pageState.restore(this.$router.currentRoute);
                  }, 1000);
                }
              })
              .catch((error) => {
                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                  case "storage/object-not-found":
                    console.log("File doesn't exist");
                    break;
                  case "storage/unauthorized":
                    console.log(
                      "User doesn't have permission to access the object"
                    );
                    break;
                  case "storage/canceled":
                    console.log("User canceled the upload");
                    break;
                  case "storage/unknown":
                    console.log(
                      "Unknown error occurred, inspect the server response"
                    );
                    break;
                }

                this.countries.push(country);

                // // End loop
                // countriesLoop--;
                // if (!countriesLoop && this.countries.length) {
                //   setTimeout(() => {
                //     var table = $("table").DataTable();
                //     pageState.filtersBackup(this.$router.currentRoute, table);
                //     pageState.restore(this.$router.currentRoute);
                //   }, 1000);
                // }
              });
          });
        });
    },
  },

  beforeRouteLeave(to, from, next) {
    pageState.backup(next, this.$router.currentRoute);
  },

  // Mounted
  mounted() {
    this.collect();
  },
};
</script>

<style lang="scss">
.admin-countries {
  table img {
    max-width: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Countries.vue